import _            from 'underscore';
import { useState } from 'react';

import { UseStateHookFunction } from '../../types';
import { Charting }             from '../../types/charting';
import { ChartType }            from 'chart.js';

export type UseChartReportingViewHook = {
	hasChartView: boolean,
	hasCustomView: boolean,
	hasToggleControls: boolean,
	
	tableViewActive: boolean,
	setTableViewActive: UseStateHookFunction<boolean>,
	
	showChartView: boolean,
	showCustomView: boolean,
	showTableView: boolean,
};

export function useChartReportingView<T extends ChartType>( chartReportProps: ( Charting.Reporting.ChartReportBaseProps<T> & Charting.Reporting.ChartReportingViewProps<T> ) ): UseChartReportingViewHook{
	
	const hasChartView  = chartReportProps.renderAsChart,
	      hasCustomView = !chartReportProps.renderAsChart && _.isFunction( chartReportProps.children );
	
	const [ tableViewActive, setTableViewActive ] = useState<boolean>( !( hasChartView || hasCustomView ) );
	
	const showChartView  = !tableViewActive && hasChartView,
	      showCustomView = !tableViewActive && hasCustomView,
	      showTableView  = tableViewActive || !chartReportProps.renderAsChart && !hasCustomView;
	
	const hasToggleControls = !_.isEmpty(
		_.compact( [
			chartReportProps.enableTableToggle,
		] )
	);
	
	return {
		hasChartView,
		hasCustomView,
		hasToggleControls,
		
		tableViewActive,
		setTableViewActive,
		
		showChartView,
		showCustomView,
		showTableView,
		
	} as UseChartReportingViewHook;
}
